import { Text } from '@consta/uikit/Text'
import { TreeInput } from '@core/components'
import {
  getAndUpdateFaults,
  selectActiveProjectId,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { BaseEntity } from '@core/core/types'
import type { BaseObject, Nullable } from 'common/types'
import type { FC } from 'react'

import css from './MapBuildingRightMenu.css'
import type { AdjustmentMenuProps } from './types'

const allowedTypes: BaseObject[] = ['faultsFolder']

const treeInputProps = {
  placeholder: 'Выбрать папку разломов',
}

export const AdjustmentMenu: FC<AdjustmentMenuProps> = ({
  updateFaultsData,
  faultsFolderValue,
  onFaultsFolderUpdate,
}) => {
  const dispatch = useAppDispatch()
  const activeProjectId = useAppSelector(selectActiveProjectId)

  const onChangeTreeInput = (value: Nullable<BaseEntity>) => {
    if (value) {
      onFaultsFolderUpdate(value)
      dispatch(getAndUpdateFaults(activeProjectId, updateFaultsData))
    } else {
      onFaultsFolderUpdate(null)
      updateFaultsData([])
    }
  }

  return (
    <div className={css.faultsInput}>
      <Text size="xs" lineHeight="2xs" view="secondary" className={css.faultsText}>
        Разломы
      </Text>
      <TreeInput
        value={faultsFolderValue}
        allowedTypes={allowedTypes}
        chooseEntityNameInsteadOfId={true}
        tooltip="Импортировать карту"
        treeInputProps={treeInputProps}
        onChange={onChangeTreeInput}
      />
    </div>
  )
}
